import type { ReactNode } from "react";
import styled from "styled-components";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const Wrap = styled.section`
  padding: ${spacing.x4}px 0;
  border-bottom: 1px solid ${colors.border};

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const Title = styled.h2`
  margin: 0 0 ${spacing.x2}px 0;
  font-size: ${fontSizes.large}px;
  font-weight: 600;
  color: ${colors.text};
`;

const Description = styled.p`
  margin: 0 0 ${spacing.x3}px 0;
  max-width: 52rem;
  font-size: 14px;
  line-height: 1.55;
  color: ${colors.textMuted};
`;

const MappingEmptyState = styled.p`
  margin: 0;
  padding: ${spacing.x3}px;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.textMuted};
  background-color: ${colors.backgroundLight};
  border: 1px solid ${colors.border};
  border-radius: ${borderRadius.regular}px;
`;

type ProductImportSectionProps = {
  title: string;
  description?: string | string[];
  children: ReactNode;
};

export const ProductImportSection = ({ title, description, children }: ProductImportSectionProps) => {
  const paragraphs =
    description === undefined
      ? []
      : Array.isArray(description)
        ? description
        : [description];

  return (
    <Wrap>
      <Title>{title}</Title>
      {paragraphs.map((text, i) => (
        <Description key={i}>{text}</Description>
      ))}
      {children}
    </Wrap>
  );
};

type MappingPlaceholderProps = {
  message: string;
};

export const MappingPlaceholder = ({ message }: MappingPlaceholderProps) => (
  <MappingEmptyState>{message}</MappingEmptyState>
);
